import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./ContactUsModal.scss";
import { ComponentProps } from "./types";
import { CustomModalWeb } from "../../../web/pages/userProfile/CustomModalWeb";
import ContactUsHtmlParseComponent from "./ContactUsHtmlParseComponent";

export default ({
  isOpen,
  onPhoneNumberClick,
  onClosed,
  contactDetails
}: ComponentProps) => {
  const { t } = useTranslation();
  const divRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if(divRef.current){
     const anchorElement = divRef.current.querySelector("a[href^='tel:']")
    
      if (anchorElement) {
        anchorElement.addEventListener('click', () => {
          handleAnchorClick();
        });
      }
      return () => {
        if (anchorElement) {
          anchorElement?.removeEventListener('click', () => null);
        }
      };
    }
    
  }, [contactDetails]);
  const handleAnchorClick =() =>
  {
    onPhoneNumberClick && onPhoneNumberClick();
  }
  const ContactUsModalProps = {
    isModalOpen: isOpen,
    title: t("Contact Us"),
    contentAlignment: "left",
    aditionalCssClass : "contactUsModal",
    size: "small_height",
    contentScroll: "deny",
    buttons: [
      {
        title: t("Ok"),
        type: "primary-cta-btn-web",
        onClick: () => {
          onClosed();
        }
      }
    ]
  };
  return (
    <CustomModalWeb {...ContactUsModalProps}>
        <div className="card">
          <div className="logo">
            <img className="img" src="assets/icon/sni-Logo.png" />
          </div>
          <div ref={divRef} className="contact-info">
          <ContactUsHtmlParseComponent richText={contactDetails} isRichText={false} />
          </div>
        </div>
    </CustomModalWeb>
  );
};
